import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getFirstName } from '../../../../../../helpers/users'
import {
  getRoleDisplayName,
  isSuperAdmin,
  isReviewer,
} from '../../../../../../helpers/user'
// store
import { getUserObject } from '../../../../../../store/selectors/userProfile'

// helper
import { useIsMobileView } from '../../../../../../utils/isMobileView'

const useStyles = makeStyles({
  banner: {
    backgroundColor: '#fff',
    padding: '20px',
  },
  bannerMobile: {
    backgroundColor: '#fff',
    padding: '20px',
    marginTop: '50px',
  },
})

const WelcomeBanner = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const userData = useSelector(getUserObject)
  const accessRole = getRoleDisplayName()
  const check = isSuperAdmin()
  const isMobileView = useIsMobileView()
  const location = useLocation()

  const renderWelcomeMessage = () => {
    if (location.pathname === '/reviews' && isReviewer()) {
      return t('review-welcome-message')
    }

    if (check) {
      return t('Access-super-tools')
    }

    return t('Access-tools')
  }

  return (
    <div className={isMobileView ? classes.bannerMobile : classes.banner}>
      <h1
        style={{
          paddingLeft: isMobileView ? '10px' : '110px',
          margin: '0',
          fontFamily: 'Johnson Display',
          fontSize: '28px',
          display: 'inline',
        }}
      >
        {t('welcome-banner-hi')} {getFirstName(userData)}!
      </h1>
      {accessRole && location.pathname !== '/reviews' && (
        <p
          style={{
            display: 'inline',
            fontSize: '11px',
            marginLeft: '16px',
            backgroundColor: 'rgb(207 244 255)',
            borderRadius: '20px',
            padding: '4px 9px',
            fontFamily: 'Johnson Display',
            verticalAlign: '4px',
            fontWeight: 'bold',
          }}
        >
          {accessRole === 'Super Admin' ? 'Super-admin' : accessRole}
        </p>
      )}
      {isReviewer() && location.pathname === '/reviews' && (
        <p
          style={{
            display: 'inline',
            fontSize: '11px',
            marginLeft: '16px',
            backgroundColor: 'rgb(207 244 255)',
            borderRadius: '20px',
            padding: '4px 9px',
            fontFamily: 'Johnson Display',
            verticalAlign: '4px',
            fontWeight: 'bold',
          }}
        >
          {t('reviewer-role')}
        </p>
      )}
      <p
        style={{
          paddingLeft: isMobileView ? '10px' : '110px',
          margin: '-10px 0px 0px',
          fontFamily: 'Johnson Display',
          fontSize: '22px',
          paddingTop: '5px',
        }}
      >
        {renderWelcomeMessage()}
      </p>
    </div>
  )
}

export default WelcomeBanner
